export const CATEGORY_LIST_REQUEST = 'CATEGORY_LIST_REQUEST';
export const CATEGORY_LIST_SUCCESS = 'CATEGORY_LIST_SUCCESS';
export const CATEGORY_LIST_FAILURE = 'CATEGORY_LIST_FAILURE';

export const RESTAURANT_GET_REQUEST = 'RESTAURANT_GET_REQUEST';
export const RESTAURANT_GET_SUCCESS = 'RESTAURANT_GET_SUCCESS';
export const RESTAURANT_GET_FAILURE = 'RESTAURANT_GET_FAILURE';

export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST';
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_FAILURE = 'PRODUCT_LIST_FAILURE';

export const ORDER_SET_TYPE = 'ORDER_SET_TYPE';
export const ORDER_REMOVE_ITEM = 'ORDER_REMOVE_ITEM';
export const ORDER_ADD_ITEM = 'ORDER_ADD_ITEM';
export const ORDER_CLEAR = 'ORDER_CLEAR';

export const PAYMENT_SET_TYPE = 'PAYMENT_SET_TYPE';

export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST';
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCESS';
export const ORDER_CREATE_FAILURE = 'ORDER_CREATE_FAILURE';

export const ORDER_LIST_REQUEST = 'ORDER_LIST_REQUEST';
export const ORDER_LIST_SUCCESS = 'ORDER_LIST_SUCCESS';
export const ORDER_LIST_FAILURE = 'ORDER_LIST_FAILURE';

export const SCREEN_SET_WIDTH = 'SCREEN_SET_WIDTH';

export const ORDER_QUEUE_REQUEST = 'ORDER_QUEUE_REQUEST';
export const ORDER_QUEUE_SUCCESS = 'ORDER_QUEUE_SUCCESS';
export const ORDER_QUEUE_FAILURE = 'ORDER_QUEUE_FAILURE';
// MATRIZID: captura query ?matrizId= (uma vez), persiste em localStorage e usa sempre de lá
// Com validações melhoradas para evitar valores undefined/null
export const MATRIZID = (() => {
	try {
		if (typeof window !== 'undefined' && window.location) {
			// Tentar pegar da URL
			const url = new URL(window.location.href);
			const q = url.searchParams.get('matrizId');
			if (q && q.trim() !== '' && q !== 'undefined' && q !== 'null') {
				try { 
					localStorage.setItem('matrizId', q.trim()); 
					console.log(`MATRIZID definido da URL: ${q.trim()}`);
					return q.trim();
				} catch (_) {
					console.warn('Erro ao salvar matrizId no localStorage');
				}
			}
			
			// Tentar pegar do localStorage
			const stored = localStorage.getItem('matrizId');
			if (stored && stored.trim() !== '' && stored !== 'undefined' && stored !== 'null') {
				console.log(`MATRIZID carregado do localStorage: ${stored.trim()}`);
				return stored.trim();
			}
		}
	} catch (error) {
		console.warn('Erro ao processar MATRIZID:', error);
	}
	
	// Tentar variável de ambiente
	if (import.meta?.env?.VITE_MATRIZ_ID) {
		console.log(`MATRIZID definido da variável de ambiente: ${import.meta.env.VITE_MATRIZ_ID}`);
		return import.meta.env.VITE_MATRIZ_ID;
	}
	
	// Fallback padrão
	console.warn('MATRIZID não encontrado, usando valor padrão: 1');
	return '1';
})();

// TOTEMID: captura query ?totemId= (uma vez), persiste em localStorage e usa sempre de lá
// Com validações melhoradas para evitar valores undefined/null
export const TOTEMID = (() => {
	try {
		if (typeof window !== 'undefined' && window.location) {
			// Tentar pegar da URL
			const url = new URL(window.location.href);
			const q = url.searchParams.get('totemId');
			if (q && q.trim() !== '' && q !== 'undefined' && q !== 'null') {
				try { 
					localStorage.setItem('totemId', q.trim()); 
					console.log(`TOTEMID definido da URL: ${q.trim()}`);
					return q.trim();
				} catch (_) {
					console.warn('Erro ao salvar totemId no localStorage');
				}
			}
			
			// Tentar pegar do localStorage
			const stored = localStorage.getItem('totemId');
			if (stored && stored.trim() !== '' && stored !== 'undefined' && stored !== 'null') {
				console.log(`TOTEMID carregado do localStorage: ${stored.trim()}`);
				return stored.trim();
			}
		}
	} catch (error) {
		console.warn('Erro ao processar TOTEMID:', error);
	}
	
	// Tentar variável de ambiente
	if (import.meta?.env?.VITE_TOTEM_ID) {
		console.log(`TOTEMID definido da variável de ambiente: ${import.meta.env.VITE_TOTEM_ID}`);
		return import.meta.env.VITE_TOTEM_ID;
	}
	
	// Fallback padrão - IMPORTANTE: sem totem ID, o sistema deve alertar
	console.error('⚠️ TOTEMID não encontrado! Configure o totem antes de usar.');
	return null;
})();

// Add the new constant for WhatsApp number
export const WHATSAPP_NUMBER_SET = 'WHATSAPP_NUMBER_SET';
export const PIXQRCODE_SET = 'PIXQRCODE_SET';

// Programa de Fidelidade constants
export const LOYALTY_POINTS_REQUEST = 'LOYALTY_POINTS_REQUEST';
export const LOYALTY_POINTS_SUCCESS = 'LOYALTY_POINTS_SUCCESS';
export const LOYALTY_POINTS_FAILURE = 'LOYALTY_POINTS_FAILURE';
export const LOYALTY_POINTS_CLEAR = 'LOYALTY_POINTS_CLEAR';
export const LOYALTY_CALCULATE_POINTS_REQUEST = 'LOYALTY_CALCULATE_POINTS_REQUEST';
export const LOYALTY_CALCULATE_POINTS_SUCCESS = 'LOYALTY_CALCULATE_POINTS_SUCCESS';
export const LOYALTY_CALCULATE_POINTS_FAILURE = 'LOYALTY_CALCULATE_POINTS_FAILURE';
